import styled from 'styled-components';
import MoreVertIcon from '@material-ui/icons/MoreVert';

export const StyledMoreVertIcon = styled(MoreVertIcon)`
  margin: 0 10px;
  cursor: pointer;
  transition: color 0.2s;
  &:hover {
    color: var(--secondary);
  }
`;
